import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-dark text-white py-8 px-4 mt-8">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p>&copy; {currentYear} PolicyPulse - Danish Parliament Analysis</p>
          <div className="mt-2 md:mt-0">
            <a 
              href="https://www.ft.dk/dokumenter/dokumentlister/referater" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary-light no-underline transition hover:text-white hover:underline"
            >
              Folketinget Transcripts
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
